import { hydrateRoot, createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { loadableReady } from "@loadable/component";
import { Hydrate, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import IntlProviderWithRecoil from "providers/IntlProvider";
import { queryClient } from "./queryClient";
import { TradeApp } from "index";
import { RecoilRoot } from "recoil";
import { CurrentAppPathnameState } from "store/data/Contract";
import "requestidlecallback-polyfill";

interface TradeFlagType {
  isSSR: boolean;
}

const dehydratedState = document.querySelector(
  "#__REACT_QUERY_STATE__"
)?.textContent;

const tradeFlag: TradeFlagType = JSON.parse(
  document.querySelector("#__COINTR_TRADE_FLAG__")?.textContent
);

const ClientApp = () => {
  function initializeState({ set }) {
    const pathname = window.location.pathname;
    set(CurrentAppPathnameState, pathname);
  }

  return (
    <BrowserRouter>
      <RecoilRoot override={true} initializeState={initializeState}>
        <QueryClientProvider client={queryClient}>
          <Hydrate state={JSON.parse(dehydratedState)}>
            <IntlProviderWithRecoil>
              <HelmetProvider>
                <TradeApp />
              </HelmetProvider>
            </IntlProviderWithRecoil>
          </Hydrate>
        </QueryClientProvider>
      </RecoilRoot>
    </BrowserRouter>
  );
};

const root = document.querySelector("#root");

// tradeFlag.isSSR
false
  ? loadableReady(() => {
      hydrateRoot(root, <ClientApp />);
    })
  : createRoot(root).render(<ClientApp />);

// // 运行所属的环境
const env = process.env.REACT_APP_ENV;
if ("serviceWorker" in navigator && ["beta", "online"].includes(env)) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/trading-bot/client/service-worker.js")
      .then((registration) => {
        // console.log('SW registered: ', registration)
      })
      .catch((registrationError) => {
        console.error("SW registration failed: ", registrationError);
      });
  });
}
